<template>
<b-row class="email no-gutters">
  <b-col class="tool-border" cols="12">
    <b-col class="reduce-padding" cols="12">
      <wlpHeader :pageTitle="pageTitle"></wlpHeader>
    </b-col>
    <b-col class="page-background-gradient reduce-padding" cols="12">
      <b-row class="page-content  no-gutters">
        <b-row class="body-sec no-gutters">
          <div class = "email">
          <b-row class = "no-gutters">
            <div class ="envelop-image"></div>
            <div class = "main-txt">{{$t('email.maintext1')}}<i>{{$t('email.maintext2')}}</i>{{$t('email.maintext3')}}<span class="double-spacing"></span>{{$t('email.maintext4')}}</div>
          </b-row>
          <b-col class = "reduce-padding" cols="12">
                <div class="email-sec cmn-sec">
                  <div class="txt-bold">{{$t('email.destination')}}</div>
                  <div class="input-feilds ">
                    <b-row class="no-gutters">
                      <b-col lg="5" class="reduce-padding">
                        <div class=" field-size"  :class="{'haserror': submitted && ((!$v.emailiD.required) || (!$v.emailiD.email)) }">
                          <input class="common-field form-control" type="email" id="emailiD" name="emailiD"  v-model="emailiD" :class="{ 'is-invalid': submitted && $v.emailiD.$error }" >
                        </div>
                      </b-col>

                      <b-col lg="7" class="reduce-padding">
                          <div class="error" v-if="submitted && (!$v.emailiD.required)">{{$t('email.error-required')}}</div>
                  <div class="error" v-if="submitted && !$v.emailiD.email">{{$t('email.invalidemail')}}</div>
                      </b-col>
                    </b-row>
                  </div>
                </div>
          </b-col>
          <b-col class = "reduce-padding" cols="12">
                <div class="email-sec cmn-sec">
                  <div class="txt-bold">{{$t('email.name')}} <span class ="normal-text">({{$t('email.nameDetails')}}):</span></div>
                  <div class="input-feilds ">
                    <b-row class="no-gutters">
                      <b-col lg="5" class="reduce-padding">
                        <div class=" field-size"  :class="{'haserror': submitted && (!$v.friendName.required  || !$v.friendName.alpha)}">
                          <input class="common-field form-control" maxLength="100" type="text" id="friendName" name="friendName"  v-model="friendName">
                        </div>
                      </b-col>

                      <b-col lg="7" class="reduce-padding">
                        <div class="error" v-if="submitted && (!$v.friendName.required  || !$v.friendName.alpha)">{{$t('email.error-required')}}</div>
                      </b-col>
                    </b-row>
                  </div>
                </div>
          </b-col>
          <b-row class ="no-gutters">
            <div class = "button-section">
              <button class = "btn-submit" @click.prevent="handleSubmit($event, emailiD, friendName)">{{$t('email.submit')}}</button>
            </div>
            
          </b-row>
          <b-row class =" no-gutters">
            <div class="footer-txt" :class="{'footer-txt-sp' : $i18n.locale=='sp'}"><i><b>{{$t('email.footerText1')}}</b><span class="double-spacing"></span>{{$t('email.footerText2')}}</i>
            </div>
          </b-row>
          </div>
        </b-row>
      </b-row>
      
      <wlpNavigation :navButtons="['previous']" :isEmail="true"></wlpNavigation>
    </b-col>

  </b-col>
</b-row>
</template>

<script>
  /* eslint-disable */
  import scrollMixin from "../mixins/scrollMixin";
  import wlpNavigation from '../components/wlpNavigation.vue';
  import wlpHeader from '../components/wlpHeader.vue';
    import axios from 'axios';
      import { required, email, minLength, alpha } from "vuelidate/lib/validators";
      
  export default {
    name: "email",
    mixins: [scrollMixin],
    mounted: function () {
      this.setValues();
      this.scrollToTop();
      
    },
    components: {
      'wlpHeader': wlpHeader,
      'wlpNavigation': wlpNavigation
    },
  
    data() {
      return {
        pageTitle: this.$t('email.pageTitle'),
      
          emailiD: "",
        friendName: "",
        submitted: false
      };
    },
    
     validations: {
      friendName: {
        required,
        alpha
      },
      emailiD: {
        required,
        email
      },
      
    },
    
    methods: {
      setValues: function(){
	     var emailid = document.getElementById('emailiD');
	       emailid.setAttribute("placeholder", this.$t('email.typeHere'));
          var friendName = document.getElementById('friendName');
	       friendName.setAttribute("placeholder", this.$t('email.typeHere'));
	  },
          handleSubmit(e, email, name) {
        console.log('e', e, '-email-', email, '-name-', name);
        this.submitted = true;
        
        //this.$v.$touch();
        if (this.$v.$invalid) {
          this.scrollToError();
          console.log("in invalid", this.$v)
          return;
        }
        else {
          const config = this.$config.config;
          const serviceUrl = config.serviceUrl2;
          const url = window.location.href;
          const parts = url.split('://');
          const schema = parts[0];
          const uri = parts[1]
            .replace(/#.*$/, '')
            .replace(/\/[^\/]*$/, '');
          const appUrl = `${schema}://${uri}/index.html`;
          const emailUrl = `${schema}://${uri}/share.html.tpl`;

          axios({
              method: 'post',
              url: `${serviceUrl}/v1/email`,
              data: {
                to: email,
                subject: "Weight-loss Profile Tool",
                template: {
                  url: emailUrl,
                  params: {
                    Name: name,
                    URL: appUrl
                  }
                }
              },
              headers: { 'X-App-ID': config.apiKey }
            })
            .then(response => {
              console.log("in response ", response)
              this.$router.go(-1);
            })
            .catch(e => {
              // TODO display error on page.
              console.log('error',e);
            })
        }
      }
    }
  };
</script>


<style lang="scss" scoped>
</style>
